// Wishlist functionality for bbp-affiliate theme
(function() {
  'use strict';

  const WISHLIST_STORAGE_KEY = 'wishlist-items';
  const WISHLIST_BUTTON_SELECTOR = '[data-wishlist-btn]';

  /**
   * Get wishlist from localStorage
   */
  function getWishlist() {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (e) {
      console.error('Error reading wishlist from localStorage:', e);
      return [];
    }
  }

  /**
   * Save wishlist to localStorage
   */
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(wishlist));
    } catch (e) {
      console.error('Error saving wishlist to localStorage:', e);
    }
  }

  /**
   * Check if product is in wishlist
   */
  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.includes(parseInt(productId));
  }

  /**
   * Add product to wishlist
   */
  function addToWishlist(productId) {
    const wishlist = getWishlist();
    const id = parseInt(productId);
    if (!wishlist.includes(id)) {
      wishlist.push(id);
      saveWishlist(wishlist);
      updateWishlistButtons(id, true);
      return true;
    }
    return false;
  }

  /**
   * Remove product from wishlist
   */
  function removeFromWishlist(productId) {
    const wishlist = getWishlist();
    const id = parseInt(productId);
    const index = wishlist.indexOf(id);
    if (index > -1) {
      wishlist.splice(index, 1);
      saveWishlist(wishlist);
      updateWishlistButtons(id, false);
      return true;
    }
    return false;
  }

  /**
   * Toggle product in wishlist
   */
  function toggleWishlist(productId) {
    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      return false;
    } else {
      addToWishlist(productId);
      return true;
    }
  }

  /**
   * Update all wishlist buttons for a product
   */
  function updateWishlistButtons(productId, isInWishlist) {
    const buttons = document.querySelectorAll(`[data-wishlist-btn][data-product-id="${productId}"]`);
    buttons.forEach(button => {
      if (isInWishlist) {
        button.classList.add('is-wishlisted');
      } else {
        button.classList.remove('is-wishlisted');
      }
    });
  }

  /**
   * Initialize wishlist buttons
   */
  function initializeWishlistButtons() {
    const buttons = document.querySelectorAll(WISHLIST_BUTTON_SELECTOR);
    
    buttons.forEach(button => {
      // Check if product is already in wishlist
      const productId = button.dataset.productId;
      if (productId && isInWishlist(productId)) {
        button.classList.add('is-wishlisted');
      }

      // Add click handler
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productId = this.dataset.productId;
        const isNowInWishlist = toggleWishlist(productId);
        
        // Update button state
        if (isNowInWishlist) {
          this.classList.add('is-wishlisted');
        } else {
          this.classList.remove('is-wishlisted');
        }
      });
    });
  }

  /**
   * Get wishlist data for page (for wishlist page)
   */
  window.getWishlistData = function() {
    const wishlist = getWishlist();
    return {
      items: wishlist,
      count: wishlist.length
    };
  };

  /**
   * Get wishlist product IDs formatted for Shopify search
   */
  window.getWishlistProductIds = function() {
    return getWishlist();
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWishlistButtons);
  } else {
    initializeWishlistButtons();
  }

  // Re-initialize when new content is dynamically added
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches?.(WISHLIST_BUTTON_SELECTOR)) {
              // Single button added
              const productId = node.dataset.productId;
              if (productId && isInWishlist(productId)) {
                node.classList.add('is-wishlisted');
              }
              node.addEventListener('click', function(e) {
                e.preventDefault();
                const isNowInWishlist = toggleWishlist(productId);
                if (isNowInWishlist) {
                  node.classList.add('is-wishlisted');
                } else {
                  node.classList.remove('is-wishlisted');
                }
              });
            } else if (node.querySelectorAll) {
              // Check for buttons within added content
              const newButtons = node.querySelectorAll(WISHLIST_BUTTON_SELECTOR);
              newButtons.forEach(button => {
                const productId = button.dataset.productId;
                if (productId && isInWishlist(productId)) {
                  button.classList.add('is-wishlisted');
                }
                button.addEventListener('click', function(e) {
                  e.preventDefault();
                  const isNowInWishlist = toggleWishlist(productId);
                  if (isNowInWishlist) {
                    button.classList.add('is-wishlisted');
                  } else {
                    button.classList.remove('is-wishlisted');
                  }
                });
              });
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
